export default __webpack_public_path__ + "img/8884889c2097e974f03105e4407e4c70.svg";